import { forwardRef } from 'react';
import { Alert, AlertProps } from '@lemon-io/ui-kit';
import { Box } from '@mui/material';
import { closeSnackbar, CustomContentProps, SnackbarContent } from 'notistack';

const createSnackbarVariant = (alertSeverity?: AlertProps['severity']) => {
  return forwardRef<HTMLDivElement, CustomContentProps>(function Snackbar(
    { id, message, ...other }: CustomContentProps,
    ref
  ) {
    return (
      <SnackbarContent ref={ref} role="alert" {...other}>
        <Box
          sx={{
            width: '665px',
            borderRadius: '4px',
            backgroundColor: 'background.paper',
          }}
        >
          <Alert
            sx={{ width: '100%' }}
            severity={alertSeverity}
            onClose={() => closeSnackbar(id)}
            action={
              typeof other.action === 'function'
                ? other.action(id)
                : other.action
            }
          >
            {message}
          </Alert>
        </Box>
      </SnackbarContent>
    );
  });
};

export const SuccessSnackbar = createSnackbarVariant('success');

export const InfoSnackbar = createSnackbarVariant('info');

export const ErrorSnackbar = createSnackbarVariant('error');

export const WarningSnackbar = createSnackbarVariant('warning');
